import * as types from '../actions/_actionTypes';
import initialState from './_initialState';

export default function integrationJobContentReducer(state = initialState.integrationJobContent, action: any) {
    switch (action.type) {
        case types.SAVE_INTEGRATION_JOB_CONTENT:
            return action.integrationJobContent;
        default:
            return state;
    }
}
